import React, { useEffect, useState } from "react";
import { Select } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../../api";

const AgentSelect = ({ value, selectedId, onChange, onSelectID, placeholder = "Select Agent", ...props }) => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/agents`);
        setAgents(response.data);
      } catch (error) {
        setAgents([]);
      } finally {
        setLoading(false);
      }
    };
    fetchAgents();
  }, []);

  const displayValue = value
    ? value
    : (selectedId ? agents.find(doc => doc._id === selectedId || doc.id === selectedId)?.name : undefined);

  return (
    <Select
      showSearch
      value={displayValue}
      onChange={(val) => {
        if (onChange) onChange(val);
        if (onSelectID) {
          const selectedAgent = agents.find(doc => doc.name === val);
          onSelectID(selectedAgent?._id || selectedAgent?.id || null);
        }
      }}
      placeholder={placeholder}
      loading={loading}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    >
      {agents
        .filter((agent) => agent?.status !== "inactive" || agent._id === selectedId || agent.id === selectedId || agent.name === value)
        .map((agent) => (
          <Select.Option key={agent._id || agent.id} value={agent.name}>
            {agent.name} {agent?.status === "inactive" ? "(Disabled)" : ""}
          </Select.Option>
        ))}
    </Select>
  );
};

export default AgentSelect;
